export default __webpack_public_path__ + "img/close_button_gray.28417e71.svg";